import className from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Loader } from '../Loader/Loader';

import './FeedbackSurveyFrame.css';

export interface SurveyData {
    event: SurveyDataEventType;
}

export enum SurveyDataEventType {
    rendered = 'survey.embed.rendered',
    rejected = 'survey.embed.rejected',
    finished = 'survey.embed.finished',
    firstAnswerGiver = 'survey.embed.first_answer_given'
}

export interface FeedbackSurveyFrameProps {
    onLoad?: () => void;
    onFinished?: () => void;
    onRejected?: () => void;
    onRendered?: () => void;
    cls?: string;
}

export interface FeedbackSurveyFrameState {
    isLoading: boolean;
}

const YANDEX_SURVEY = 'https://yandex.ru/poll/enter/2yGRY3qQwvTjTCeondqLL9?_footer_enable_=0&_progress_bar_enable_=0';

export class FeedbackSurveyFrame extends React.PureComponent<FeedbackSurveyFrameProps, FeedbackSurveyFrameState> {
    constructor(props: FeedbackSurveyFrameProps) {
        super(props);

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        const { onFinished, onRendered, onRejected } = this.props;

        window.addEventListener('message', ev => {
            const parsedEventData = this.getJSON(ev.data);

            if (parsedEventData && parsedEventData.event) {
                switch (parsedEventData.event) {
                    case SurveyDataEventType.finished:
                        if (onFinished) {
                            onFinished();
                        }
                        break;
                    case SurveyDataEventType.rejected:
                        if (onRejected) {
                            onRejected();
                            this.setState({
                                isLoading: false
                            });
                        }
                        break;
                    case SurveyDataEventType.rendered:
                        if (onRendered) {
                            onRendered();
                            this.setState({
                                isLoading: false
                            });
                        }
                        break;
                    // Можно поймать чужой event. Поэтому лучше оставить блок default пустым.
                    default:
                        break;
                }
            }
        });
    }

    render() {
        const { onLoad, cls } = this.props;
        const { isLoading } = this.state;

        return (
            <div className="feedback-survey-frame">
                {isLoading ? <Loader size={'s'} /> : null}
                <iframe
                    onLoad={onLoad}
                    src={YANDEX_SURVEY}
                    frameBorder="0"
                    className={className(
                        Bem.cls({
                            block: 'feedback-survey-frame',
                            elem: 'frame',
                            mods: {
                                loading: isLoading
                            }
                        }),
                        cls
                    )}
                />
            </div>
        );
    }

    private getJSON(data?: string) {
        try {
            if (typeof data === 'string') {
                return JSON.parse(data) as SurveyData;
            } else {
                return undefined;
            }
        } catch (e) {
            return undefined;
        }
    }
}
